<template>
    <section class="shipment-details">
        <div class="flex-3">
            <div class="v-flex-2">
                <p class="detail courier">
                    <span>
                        <small class="detail-text"
                            >Courier
                            <img
                                src="https://i.imgur.com/NiAVkEw.png"
                                width="25"
                            />
                        </small>
                    </span>
                    <!-- <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS8zR3Aiw2BMPaRctGTPOis9BWCW2xbtUBXcyH1EAxPpc7Q_Wa86n35JwZ-CLZ8kLY25l0&usqp=CAU" width="40" style="vertical-align: middle;"/><br> -->
                    <span class="theme-color"><a :href="tracking.partner_tracking_url" target="_blank">{{ tracking.partner }}</a></span>
                </p>
                <p class="detail">
                    <small class="detail-text">Last Update </small><br />
                    <span>
                        <span class="theme-color"
                            >{{
                                tracking.current_status.replace("Shipment", "")
                            }} </span
                        >on {{ tracking.current_status_date_time | toFullDate }}
                    </span>
                </p>
            </div>
            <div class="v-flex-2">
                <p class="detail grid-center">
                    <small class="detail-text">Tracking ID </small><br />
                    <span class="theme-color">{{ tracking.awb_no }} </span>
                    <a href="#" v-on:click="copyToClipboard(tracking.awb_no)"><svg width="24px" height="24px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#868e96" class="w-6 h-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                      </svg></a>
                </p>
                <p class="detail grid-center">
                    <small class="detail-text">Expected Delivery </small><br />
                    <span class="theme-color">{{ getEstimatedDeliveryDate(tracking) }}</span>
                </p>
            </div>
            <div class="v-flex-2">
                <p class="detail grid-end">
                    <small class="detail-text">Order ID</small> <br />
                    <span class="theme-color">{{ tracking.order_id }}</span>
                </p>
                <p class="detail grid-end">
                    <small class="detail-text">Product</small> <br />
                    <span class="theme-color detail-texate">
                        {{ tracking.product }}
                    </span>
                </p>
            </div>
            <span ref="clipboard"></span>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        tracking: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            arrowIcon: require("../assets/img_118016.png"),
            partnerMappings: {
              "7": "https://www.delhivery.com/track/#/package/<tracking_id>",
              "3": "https://www.aramex.com/track/results?ShipmentNumber=<tracking_id>",
              "18": "https://www.aramex.com/track/results?ShipmentNumber=<tracking_id>",
              "23": "https://ecomexpress.in/tracking/?awb_field=<tracking_id>&s=",
              "22": "http://wowexpress.in/TrackService.aspx?dff=<tracking_id>",
              "26": "https://www.gati.com/track-by-docket/",
              "39": "https://www.fedex.com/apps/fedextrack/?action=track&tracknumbers=<tracking_id>&locale=en_IN&cntry_code=in",
              "114": "https://www.fedex.com/apps/fedextrack/?action=track&tracknumbers=<tracking_id>&locale=en_IN&cntry_code=in",
              "120": "https://www.xpressbees.com/track?isawb=Yes&trackid=<tracking_id>",
              "128": "http://track.delhivery.com/p/<tracking_id>",
              "130": "https://ekartlogistics.com/shipmenttrack/<tracking_id>/",
              "126": "https://ekartlogistics.com/shipmenttrack/<tracking_id>/",
              "131": "https://www.xpressbees.com/search?csrf_test_name=fdbe7a3f0cde4ad66f65cd9b4fa07bd1&trackid=<tracking_id>&isawb=Yes",
              "37": "https://track.shadowfax.in/track?order=new&trackingId=<tracking_id>",
              "141": "https://track.shadowfax.in/track?order=new&trackingId=<tracking_id>",
              "143": "https://track.shadowfax.in/track?order=new&trackingId=<tracking_id>",
              "137": "https://www.bluedart.com/web/guest/home?p_p_id=track_dart_WAR_Track_Dartportlet&p_p_lifecycle=1&p_p_state=normal&p_p_mode=view&_track_dart_WAR_Track_Dartportlet_javax.portlet.action=fetchTrackingDetails&p_auth=vMgC9tTC&_track_dart_WAR_Track_Dartportlet_trackingNo=<tracking_id>&_track_dart_WAR_Track_Dartportlet_selectedVal=0",
              "119": "https://www.bluedart.com/web/guest/home?p_p_id=track_dart_WAR_Track_Dartportlet&p_p_lifecycle=1&p_p_state=normal&p_p_mode=view&_track_dart_WAR_Track_Dartportlet_javax.portlet.action=fetchTrackingDetails&p_auth=vMgC9tTC&_track_dart_WAR_Track_Dartportlet_trackingNo=<tracking_id>&_track_dart_WAR_Track_Dartportlet_selectedVal=0",
              "145": "https://www.bluedart.com/web/guest/home?p_p_id=track_dart_WAR_Track_Dartportlet&p_p_lifecycle=1&p_p_state=normal&p_p_mode=view&_track_dart_WAR_Track_Dartportlet_javax.portlet.action=fetchTrackingDetails&p_auth=vMgC9tTC&_track_dart_WAR_Track_Dartportlet_trackingNo=<tracking_id>&_track_dart_WAR_Track_Dartportlet_selectedVal=0",
              "138": "https://www.xpressbees.com/track?isawb=Yes&trackid=<tracking_id>",
              "136": "https://ekartlogistics.com/shipmenttrack/<tracking_id>/",
              "157": "https://www.fedex.com/apps/fedextrack/?action=track&tracknumbers=<tracking_id>&locale=en_IN&cntry_code=in",
              "146": "https://ecomexpress.in/tracking/?awb_field=<tracking_id>&s=",
              "148": "https://ecomexpress.in/tracking/?awb_field=<tracking_id>&s=",
              "149": "https://ecomexpress.in/tracking/?awb_field=<tracking_id>&s=",
              "150": "https://ecomexpress.in/tracking/?awb_field=<tracking_id>&s=",
              "155": "https://www.fedex.com/apps/fedextrack/?action=track&tracknumbers=<tracking_id>&locale=en_IN&cntry_code=in",
              "156": "https://www.fedex.com/apps/fedextrack/?action=track&tracknumbers=<tracking_id>&locale=en_IN&cntry_code=in",
              "133": "https://www.delhivery.com/track/#/package/<tracking_id>",
              "139": "https://www.delhivery.com/track/#/package/<tracking_id>",
              "140": "https://www.delhivery.com/track/#/package/<tracking_id>",
              "147": "https://www.delhivery.com/track/#/package/<tracking_id>",
              "154": "https://www.delhivery.com/track/#/package/<tracking_id>",
              "158": "https://www.delhivery.com/track/#/package/<tracking_id>",
              "159": "https://www.delhivery.com/track/#/package/<tracking_id>",
              "160": "https://www.delhivery.com/track/#/package/<tracking_id>",
              "161": "https://track.shadowfax.in/track?order=new&trackingId=<tracking_id>",
              "152": "https://track.shadowfax.in/track?order=new&trackingId=<tracking_id>",
              "170": "https://www.bluedart.com/web/guest/home?p_p_id=track_dart_WAR_Track_Dartportlet&p_p_lifecycle=1&p_p_state=normal&p_p_mode=view&_track_dart_WAR_Track_Dartportlet_javax.portlet.action=fetchTrackingDetails&p_auth=vMgC9tTC&_track_dart_WAR_Track_Dartportlet_trackingNo=<tracking_id>&_track_dart_WAR_Track_Dartportlet_selectedVal=0",
              "163": "https://www.dtdc.in/tracking/shipment-tracking.asp",
              "168": "https://www.dtdc.in/tracking/shipment-tracking.asp",
              "173": "https://www.delhivery.com/track/#/package/<tracking_id>",
              "180": "https://www.delhivery.com/track/#/package/<tracking_id>",
              "181": "https://www.delhivery.com/track/#/package/<tracking_id>",
              "182": "https://track.amazon.in/tracking/<tracking_id>?trackingId=<tracking_id>\r\n",
              "183": "https://track.amazon.in/tracking/<tracking_id>?trackingId=<tracking_id>\r\n",
              "184": "https://track.amazon.in/tracking/<tracking_id>?trackingId=<tracking_id>\r\n",
              "171": "https://www.bluedart.com/web/guest/home?p_p_id=track_dart_WAR_Track_Dartportlet&p_p_lifecycle=1&p_p_state=normal&p_p_mode=view&_track_dart_WAR_Track_Dartportlet_javax.portlet.action=fetchTrackingDetails&p_auth=vMgC9tTC&_track_dart_WAR_Track_Dartportlet_trackingNo=<tracking_id>&_track_dart_WAR_Track_Dartportlet_selectedVal=0",
              "186": "https://smartr.in/tracking",
              "189": "https://ekartlogistics.com/shipmenttrack/<tracking_id>/",
              "190": "https://ekartlogistics.com/shipmenttrack/<tracking_id>/",
              "153": "https://ekartlogistics.com/shipmenttrack/<tracking_id>/"
            }
        };
    },
    filters: {
    },
    methods: {
      toDateWithDay(date) {
          if (date === "") {
              return "";
          }
          const months = [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec"
          ];

          const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
          const month = months[date.getMonth()];

          return `${date.getDate()}-${month}-${date.getFullYear()} (${
              days[date.getDay()]
          })`;
      },
      copyToClipboard(copyText) {

        const storage = document.createElement('textarea');
        storage.value = copyText;
        this.$refs.clipboard.appendChild(storage);
        storage.select();
        storage.setSelectionRange(0, 99999);
        document.execCommand('copy');
        this.$refs.clipboard.removeChild(storage);

      },
      getEstimatedDeliveryDate(tracking) {
        if(tracking.current_status_code < 1900 && tracking.estimated_delivery_timeline !== undefined) {
          return this.toDateWithDay(tracking.estimated_delivery_timeline);
        }

        if (tracking.current_status_code < 1900) {
            const SURFACE_PRODUCT_CODES = [
                "P001",
                "P005",
                "P006",
                "P007",
                "P024"
            ];
            let daysToAdd = { wc: 3, ws: 4, mm: 4, roi: 6, ne: 8 };
            SURFACE_PRODUCT_CODES.map((value, index) => {
                if (value === this.tracking.product_code.toUpperCase()) {
                    daysToAdd = { wc: 3, ws: 5, mm: 4, roi: 7, ne: 10 };
                }
            });
            let deliveryDate = new Date(this.tracking.shipment_date);
            deliveryDate.setDate(
                deliveryDate.getDate() +
                    daysToAdd[this.tracking.shipment_zone.toLowerCase()]
            );
            if (new Date() > deliveryDate) {
                deliveryDate.setDate(new Date().getDate() + 2);
            }
            return deliveryDate;
          }
          return "";
      },
      getStatusClass(currentStatusCode) {
          let status = "warning";
          if (currentStatusCode === 1900) {
              status = "success";
          }
          if (currentStatusCode >= 2000) {
              status = "failed";
          }
          if (currentStatusCode === 1500) {
              status = "failed";
          }
          return "box " + status;
      }
    }
};
</script>
<style scoped>
#arrow-icon {
    height: 15px;
    margin-left: 10px;
    margin-right: 10px;
}
#arrow-icon.reverse {
    transform: rotate(180deg);
}
.boxx {
    padding: 1rem 1rem 0 1rem;
    min-width: 45vw;
    margin: 0;
}
.partner-logo {
    detail: right;
}

.success {
    background-color: #36b37e !important;
    color: #fff !important;
}
.success * {
    color: #fff !important;
    detail: center;
}

.failed {
    background-color: #ca3433 !important;
    color: #fff !important;
}

.failed * {
    color: #fff !important;
    detail: center;
}

.warning {
    background-color: #ffc107 !important;
    color: #fff !important;
}

.warning * {
    color: #fff !important;
    detail: center;
}

.subtitle {
    margin-bottom: 5px;
}
.location-details {
    padding-top: 40px;
    font-size: 0.9em;
}
#partner-tracking-link {
    detailation: underline;
    font-size: 0.8em;
}

#partner-logo {
    width: 70px;
    position: absolute;
    top: -88px;
    right: 35px;
}

@media screen and (max-width: 768px) {
    .column {
        detail-: center;
    }
    .origin-city,
    .arrow,
    .destination-city {
        display: table-cell;
        vertical-align: middle;
    }
    .shipment-no {
        display: inline-block;
        font-size: 0.8em;
    }
    .title {
        margin-bottom: 0px;
    }
    .subtitle {
        margin-top: 20px !important;
        margin-bottom: 5px !important;
    }
    .columns {
        margin-bottom: 0px;
    }
    .location-details {
        padding-top: 30px;
        font-size: 0.9em;
    }
}
.detail-box {
    padding: 4px 8px;
}
.d-flex {
    display: flex;
    justify-content: space-between;
}
.w-50 {
    width: 50%;
}
.text-truncate {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.theme-color {
    color: #004cb9;
    font-weight: 600;
}
hr.new1 {
    border-top: 2px dashed #fff;
    margin: 0.4rem 0;
}
.detail-text {
    color: #868e96;
}
</style>



// WEBPACK FOOTER //
// src/components/ShipmentDetails.vue